const store = [
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/2/0/8/7/2087a9ffe7a35c22f1efa212d57b0d72.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/0/0/1/1/0011220ec1da440d826af04584554fa4.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/d/e/9/1/de91f9c8b08e1fb4b35e2b64e1c2ed15.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/d/a/2/f/da2f9f07bd3cc7eeb506e2ff6690992d.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/3/c/f/9/3cf989e41d0bfc2b4cedd57077c96c20.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/9/b/8/e/9b8e8e3aca20247aa776599ba6f94ca8.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/f/6/5/5/f6553e5d6281763a103897dbefa05088.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/2/d/7/d/2d7d033ca7c2a381748e7fb9dc6aa186.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/covers/6/2/62df066e6f9196dbeedadd35931b88ae_1382408334.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/e/c/2/0/ec2075182822e919c6d014492c2375c8.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/covers/f/d/fd4276c762a53e86ec980bb373a5a805_1504774753.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/6/9/f/6/69f621e3a5655a7c984664e893af70ab.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/3/2/7/c/327cf9349a2dd014e4de2e2674856d42.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/6/a/b/8/6ab8deee3953592dc9a4cfcb81bfb1b8.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/9/5/8/5/958558fda3947519e8f679a3ff7171b8.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/0/0/d/a/00da6f15c1a9b83551f3177500b226ea.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/0/0/1/1/0011220ec1da440d826af04584554fa4.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/covers/7/3/73f10266882f174032d9b9edb162d1bc_1469415664.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/d/8/0/1/d801670cd8ecdb89750bdbe8de198021.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/f/8/1/e/f81efd92fa9a3d52eb37f3b867ab9d32.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/covers/d/d/ddeb3089b0db18448d5772f946b1c5b4_1510198011.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/covers/f/3/f3ccdd27d2000e3f9255a7e3e2c48800_1359011674.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/f/e/9/8/fe9875941d98fbbcb8aedc8960ccbc94.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/4/c/d/d/4cdda456ba944872c14dcd7c0f66d03b.jpg",
  },
  {
    url: "https://photo-resize-zmp3.zmdcdn.me/w480_r1x1_jpeg/cover/8/b/6/0/8b60c63bca80097a24b834bdb2400bf2.jpg",
  },
];

export default store;
